import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Header from '../../components/special/Header';
import { EmployeeCapacityList } from './EmployeeCapacityList';

const EmployeeCapacity = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box className="flex gap-0 md:gap-8 md:items-center justify-between md:justify-start pr-2 md:flex-row flex-col pb-4 md:pb-0 shrink-0">
        <Header title={t('Employee Capacity')} />
      </Box>
      {/* the view only covers running projects, so there is no status switch */}
      <EmployeeCapacityList />
    </>
  );
};

export default EmployeeCapacity;
